export default __webpack_public_path__ + "static/media/21.190e0c48.png";